import { useEffect } from 'react';
import type { PossibleSettings } from 'src/apis/monolith/types';
import { useAxios } from 'src/hooks/use-axios';

export function useEnabledSettings(tsoId: number | string) {
  const request = useAxios(
    (axios, baseConfig, tsoId: number | string) =>
      axios.request<PossibleSettings[]>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.monolithApiUrl}/tso/${tsoId}/enabled-settings`,
      }),
    { neededOnPageLoad: true }
  );

  useEffect(() => {
    if (!tsoId) return request.setResponse(null);
    request.execute(tsoId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tsoId]);

  return request;
}

export type EnabledSettingsRequest = ReturnType<typeof useEnabledSettings>;
